import { entityStore, store, storeActions } from '~/utility/BinSentry-ui-utility';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity, renderIf } from '../../utility/lit-entity';
import '../../common/bn-loading';
import './bin-delete';

class BinDeleteModal extends BnModalMixin(LitEntity) {
  static get properties() {
    return {
      ownerHref: { type: String, attribute: false },
    };
  }

  constructor() {
    super();
    this.id = 'bin-delete-modal';
  }

  renderContents() {
    const beginDelete = this.entity?.getActionByName('begin-delete');
    const isReady = beginDelete;

    return html`
      <style>
        bn-modal#bin-delete-modal {
          --modal-min-height: 50%;
          --modal-max-height: 95%;
        }
      </style>

      <h3 slot="title">Confirm Deleting Bin</h3>

      <lit-entity .href="${this.ownerHref}" @update="${this._onOwnerUpdate}"></lit-entity>

      ${renderIf(!isReady, html`<bn-loading></bn-loading>`)}

      ${renderIf(isReady, html`
        <bin-delete
          .href="${beginDelete.href}"
          @response="${this._onDeleteResponse}"
          @deviceremoved=${() => entityStore.invalidateHref(beginDelete.href)}
        ></bin-delete>
      `)}
    `;
  }

  _onDeleteResponse() {
    setTimeout(() => {
      store.dispatch(storeActions.navigate('/customers', { organizationId: this.ownerHref }));
    }, 2000);
  }

  _onOwnerUpdate(e) {
    this.accountHref = this.getHref('https://api.binsentry.com/rel/account', e.detail.entity);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.ownerHref = this.entity?.getSubEntity('https://api.binsentry.com/rel/owner')?.href;
  }

  open() {
    this.hide = false;
  }
}

window.customElements.define('bin-delete-modal', BinDeleteModal);
